import { findIndex } from 'lodash'

const initialState = {
  id: -1,
  type: null,
  open: false,
  temp: 25,
  time: 6990,
  // time: 0,
  itemCount: 0,
  items: [],
  countdownActive: false,
  containsTubeRack: false,
  showToolTipControls: false,
};

// export default (state = initialState, action) => {
export default (state = initialState, action) => {
  let currentWaterBath;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
      return state;
  }

  if (action.type !== "CREATE_WATER_BATH" && !action.type.includes("@redux")) {
    if(action.payload.hasOwnProperty("id")){
          if(state.protocolSection.scene.apparatus.hasOwnProperty("waterBath")){
            currentWaterBath = state.protocolSection.scene.apparatus.waterBath[findIndex(state.protocolSection.scene.apparatus.waterBath, { id: action.payload.id })]
          }
      }
  }
  switch (action.type) {
    case 'CREATE_WATER_BATH':

      //Create new obj from template state
      let newObj = { ...initialState, ...action.payload.props }

      if(protocolSection.scene.apparatus.hasOwnProperty("waterBath")){
        protocolSection.scene.apparatus.waterBath = [ ...protocolSection.scene.apparatus.waterBath, newObj ]
      } else {
        protocolSection.scene.apparatus.waterBath = [newObj]
      }

      return { ...state, ...{
        protocolSection: protocolSection
      } }


    case "ADD_ITEM_TO_WATER_BATH":
      //Payload = {newItem}
      currentWaterBath.count++;
      currentWaterBath.items = [...currentWaterBath.items, ...action.payload.newItem]
      protocolSection.scene.apparatus.waterBath[findIndex(state.waterBath, { id: action.payload.id })] = currentWaterBath

      return { ...state, ...{
        protocolSection: protocolSection
      } }

    case "REMOVE_ITEM_FROM_WATER_BATH":
      //Payload = {removeItem}
      //pop from array
      //define removeItem
      return {
        ...state,
        ...{
          count: (state.count -= 1),
          items: [...state.items, ...action.payload.removeItem]
        }
      };

    case "WATER_BATH_OPEN":
      currentWaterBath.open = action.payload.open
      protocolSection.scene.apparatus.waterBath[findIndex(state.waterBath, { id: action.payload.id })] = currentWaterBath

      return { ...state, ...{
        protocolSection: protocolSection
      } }

    case "SET_WATER_BATH_TIME":
      //Payload = {time}
      currentWaterBath.time = action.payload.time
      protocolSection.scene.apparatus.waterBath[findIndex(state.waterBath, { id: action.payload.id })] = currentWaterBath

      return { ...state, ...{
        protocolSection: protocolSection
      } }

    case "WATER_BATH_COUNT_DOWN":
      //Payload = {timeDiff}
      return {
        ...state,
        ...{ time: state.time - action.payload.timeDiff }
      };

    case "SET_WATER_BATH_TEMP":
      //Payload = {temp}
      currentWaterBath.temp = action.payload.temp
      protocolSection.scene.apparatus.waterBath[findIndex(state.waterBath, { id: action.payload.id })] = currentWaterBath

      return { ...state, ...{
        protocolSection: protocolSection
      } }

      return { ...state, ...{ temp: action.payload.temp } };

    case "WATER_BATH_COUNTDOWN_ACTIVE":
      //Payload = {active}
      return { ...state, ...{ countdownActive: action.payload.active } };

    case "WATER_BATH_CONTAINS_TUBE_RACK":
      //Payload = {containsTubeRack}
      currentWaterBath.containsTubeRack = action.payload.containsTubeRack
      protocolSection.scene.apparatus.waterBath[findIndex(state.waterBath, { id: action.payload.id })] = currentWaterBath

      return { ...state, ...{
        protocolSection: protocolSection
      } }

    case "SHOW_TOOL_TIP_CONTROLS_WATER_BATH":
      //Payload = {containsGel}
      currentWaterBath.showToolTipControls = action.payload.showToolTipControls;

      protocolSection.scene.apparatus.waterBath[
        findIndex(protocolSection.scene.apparatus.waterBath, {
          id: action.payload.id,
        })
      ] = currentWaterBath;
      return {
        ...state,
        ...{ waterBath: protocolSection.scene.apparatus.waterBath },
      };
    case "UNDO":
      //Payload = {lastState}
    
      if (action.payload.lastState !== null && protocolSection.scene.apparatus.waterBath) {
    
        protocolSection.scene.apparatus.waterBath = action.payload.lastState.scene.apparatus.waterBath
    
        return { ...state, ...{
          protocolSection: protocolSection
        } }
    
      } else {
        return state;
      }

    default:
      return state;
  }
};
